const jresearchType = {
  Set_Current_Video_Url: 'Set_Current_Video_Url',
  Set_Video_Url: 'Set_Video_Url',
  Set_Select_Number: 'Set_Select_Number',
  Set_Lecture_ID : 'Set_Lecture_ID',
};

export default jresearchType;
